import { combineReducers } from 'redux';
import alert from './alert';
import auth from './auth';
import profile from './profile';
import rank from './rank';


export default combineReducers({
  alert,
  auth,
  profile,
  rank
});